import styled from 'styled-components';
import { white } from '../../../../StylesConstants';

export const NotificationsWrapper = styled.div`
  padding-top: 32px; 
  background-color: ${white};
`;
